








































import { Component, Vue } from 'vue-property-decorator';
import Intro from '@/components/Intro.vue';
import gsap from 'gsap';
import { ScrollMagic, ScrollScene, addIndicators } from 'scrollscene';
import Position from '@/components/Position.vue';
import store from '../store';

export default {
	components: {
		Intro,
		Position,
	},
	beforeMount() {
	},
	mounted() {
		const triangleContainer = document.querySelector('.triangle-container');
		const triangle = document.querySelector('.triangles');
		const triangleInner = document.querySelector('.triangles__dates');
		const experiences = document.querySelector('.experiences');
		const positionContainers = document.querySelectorAll<HTMLElement>('.position');
		const offset = window.innerHeight / 2 - (positionContainers[0].offsetHeight / 2);

		const distance = document.querySelectorAll('.position')[0].clientHeight;
		const tl = gsap.timeline({ paused: true });

		tl.to(triangle, {
			rotateX: '360_cw',
			onUpdate() {
				// Remove previous triangle info going in reverse.
				if (triangleInner.classList.contains('triangles__dates--turned-two')) {
					triangleInner.classList.remove('triangles__dates--turned-two');
				}

				if (tl.progress() > 0.10) {
					triangleInner.classList.add('triangles__dates--turned-one');
				} else if (triangleInner.classList.contains('triangles__dates--turned-one')) {
					triangleInner.classList.remove('triangles__dates--turned-one');
				}
			},
		}).to(triangle, {
			rotateX: '359_cw',
			onUpdate() {
				if (tl.progress() > 0.35) {
					triangleInner.classList.add('triangles__dates--turned-two');
				} else if (triangleInner.classList.contains('triangles__dates--turned-two')) {
					triangleInner.classList.remove('triangles__dates--turned-two');
				}
			},
		}).to(triangle, {
			rotateX: '358_cw',
			onUpdate() {
				if (tl.progress() > 0.58) {
					triangleInner.classList.add('triangles__dates--turned-three');
				} else if (triangleInner.classList.contains('triangles__dates--turned-three')) {
					// Remove previous triangle info going in reverse.
					triangleInner.classList.remove('triangles__dates--turned-three');
				}
			},
		}).to(triangle, {
			rotateX: '357_cw',
			onUpdate() {
				if (tl.progress() > 0.82) {
					triangleInner.classList.add('triangles__dates--turned-four');
				} else if (triangleInner.classList.contains('triangles__dates--turned-four')) {
					// Remove previous triangle info going in reverse.
					triangleInner.classList.remove('triangles__dates--turned-four');
				}
			},
		});

		// Triangle - Scrollscene (https://github.com/jonkwheeler/ScrollScene - wrapper around scrollmagic to handle gsap 3).
		const triangleScene = new ScrollScene({
			triggerElement: experiences,
			duration: '360%',
			gsap: {
				timeline: tl,
			},
			offset: '200px',
		});

		const controller = new ScrollMagic.Controller();

		// Pin the triangle.
		new ScrollMagic.Scene({
			triggerElement: experiences,
			triggerHook: 'onEnter',
			offset: '200px',
		}).setPin(triangleContainer).addTo(controller);

		tl.to(document.querySelector('.position__info'), {
			top: '50%',
			y: '-50%',
		}, '0');
	},
};

